// extracted by mini-css-extract-plugin
export default {"formHeading":"WG-z","form":"XG-z","submitBtn":"YG-z","disabled":"ZG-z","input":"_G-z","error":"aH-z","submitMsg":"bH-z","signIn":"cH-z"};